// Der Content Store enthaelt nur den Tag; UserVisibility gibt ihn auf TwoStack frei.
const iwwFreeTrialPreviewSelector = 'iww-free-trial-banner, iww-dynamiccontent[type="freetrialbanner"]';
const iwwFreeTrialPreviewInitialized = new WeakSet();
const iwwFreeTrialPreviewCacheLifetime = 60 * 60 * 1000;
const iwwFreeTrialPreviewProductCache = new Map();
const iwwFreeTrialPreviewProductRequests = new Map();


const iwwFreeTrialPreviewBaseUrl = (function () {
	if (window.location.hostname.endsWith('.internal')) {
		return 'https://productrecommender.iww.internal';
	}
	try {
		return process.env.PRODUCTRECOMMENDER_URL || 'https://productrecommender.iww.de';
	} catch {
		return 'https://productrecommender.iww.de';
	}
})();

function iwwFreeTrialPreviewIsNeos() {
	// Nur der Neos-Content-Frame, nicht die edit-Domain oder ein Preview-Attribut.
	return window.self !== window.top && (
		document.body?.classList.contains('neos-backend')
		|| document.querySelector('[data-__neos-node-contextpath]') !== null
	);
}

function iwwFreeTrialPreviewReadCache(key) {
	try {
		const cached = iwwFreeTrialPreviewProductCache.get(key)
			|| JSON.parse(window.localStorage.getItem(key) || 'null');
		if (cached && Number.isFinite(cached.expiresAt)
			&& cached.expiresAt > Date.now() && Array.isArray(cached.products)
			&& cached.products.length > 0) {
			iwwFreeTrialPreviewProductCache.set(key, cached);
			return cached.products;
		}
		// Auch alte leere Delivery-Antworten sofort verwerfen statt eine Stunde warten.
		iwwFreeTrialPreviewProductCache.delete(key);
		window.localStorage.removeItem(key);
	} catch {
		// Gesperrter Browser-Speicher verhindert den Abruf nicht.
	}
	return null;
}

function iwwFreeTrialPreviewWriteCache(key, products) {
	// Ein noch nicht ausspielbares Produkt darf spaetere Seitenaufrufe nicht sperren.
	if (products.length === 0) return;
	const cached = {expiresAt: Date.now() + iwwFreeTrialPreviewCacheLifetime, products};
	iwwFreeTrialPreviewProductCache.set(key, cached);
	try {
		window.localStorage.setItem(key, JSON.stringify(cached));
	} catch {
		// Ohne localStorage gilt der Cache fuer die aktuelle Seite.
	}
}

async function iwwFreeTrialPreviewLoadProducts(url, useCache = true) {
				const key = 'iww:free-trial-products:v2:' + new URL(url, window.location.href).href;
	const cached = useCache ? iwwFreeTrialPreviewReadCache(key) : null;
	if (cached !== null) return cached;
	if (useCache && iwwFreeTrialPreviewProductRequests.has(key)) {
		return iwwFreeTrialPreviewProductRequests.get(key);
	}
	const request = (async () => {
		const response = await fetch(url, {headers: {Accept: 'application/json'}, cache: 'no-store'});
		if (!response.ok) throw new Error('HTTP ' + response.status);
		const data = await response.json();
		if (!data || !Array.isArray(data.payload)) throw new Error('Ungueltige Produktantwort');
		if (useCache) iwwFreeTrialPreviewWriteCache(key, data.payload);
		return data.payload;
	})();
	if (useCache) iwwFreeTrialPreviewProductRequests.set(key, request);
	try {
		return await request;
	} finally {
		if (useCache) iwwFreeTrialPreviewProductRequests.delete(key);
	}
}

function iwwFreeTrialPreviewFirst(product, keys) {
	for (const key of keys) {
		if (typeof product[key] === 'string' && product[key].trim() !== '') {
			return product[key].trim();
		}
	}
	return '';
}

function iwwFreeTrialPreviewFindProduct(products, identifier, informationsdienst) {
	const normalize = value => String(value ?? '').toLowerCase();
	const candidates = products.filter(product => product && typeof product === 'object' && !Array.isArray(product));
	const wanted = normalize(identifier);
	const exact = wanted && candidates.find(product =>
		normalize(product.productNumber) === wanted || normalize(product.dynamicsID) === wanted);
	if (exact) return exact;
	// Kein Fallback bei expliziter Produktauswahl.
	if (wanted && wanted !== normalize(informationsdienst)) return null;
	return candidates.find(product => normalize(product.informationsdienst) === normalize(informationsdienst)) || null;
}

function iwwFreeTrialPreviewIsWebUrl(value) {
	if (!value || /[\s\\]/.test(value)) return false;
	if (value.startsWith('/') && !value.startsWith('//')) return true;
	try {
		return ['http:', 'https:'].includes(new URL(value).protocol);
	} catch {
		return false;
	}
}

function iwwFreeTrialPreviewShopDescription(value) {
	// Das geparste Dokument bleibt getrennt. Ausschliesslich neue Textknoten und
	// b/i/u/br erzeugen; niemals Quellknoten oder Attribute in die Seite uebernehmen.
	const source = new DOMParser().parseFromString(value, 'text/html');
	const result = document.createDocumentFragment();
	const appendBreak = target => {
		if (target.hasChildNodes() && target.lastChild.nodeName !== 'BR') {
			target.append(document.createElement('br'));
		}
	};
	const append = (node, target) => {
		if (node.nodeType === Node.TEXT_NODE) {
			target.append(document.createTextNode(node.textContent));
			return;
		}
		if (node.nodeType !== Node.ELEMENT_NODE) return;
		if (node.namespaceURI !== 'http://www.w3.org/1999/xhtml'
			|| ['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'TEMPLATE', 'NOSCRIPT'].includes(node.tagName)) return;
		if (node.tagName === 'BR') {
			target.append(document.createElement('br'));
			return;
		}
		const block = ['P', 'DIV'].includes(node.tagName);
		if (block) appendBreak(target);
		let inline = target;
		const weight = node.style.fontWeight;
		const italic = node.style.fontStyle;
		if (['B', 'STRONG'].includes(node.tagName) || ['bold', 'bolder'].includes(weight) || parseInt(weight, 10) >= 600) {
			const bold = document.createElement('b');
			inline.append(bold);
			inline = bold;
		}
		if (['I', 'EM'].includes(node.tagName) || italic === 'italic' || italic.startsWith('oblique')) {
			const emphasis = document.createElement('i');
			inline.append(emphasis);
			inline = emphasis;
		}
		const decoration = node.style.textDecorationLine || node.style.textDecoration;
		if (node.tagName === 'U' || decoration.split(/\s+/).includes('underline')) {
			const underline = document.createElement('u');
			inline.append(underline);
			inline = underline;
		}
		Array.from(node.childNodes).forEach(child => append(child, inline));
		if (block) appendBreak(target);
	};
	Array.from(source.body.childNodes).forEach(node => append(node, result));
	while (result.lastChild && (result.lastChild.nodeName === 'BR'
		|| (result.lastChild.nodeType === Node.TEXT_NODE && !result.lastChild.textContent.trim()))) {
		result.lastChild.remove();
	}
	return result;
}

function iwwFreeTrialPreviewRender(element, product) {
	const fields = {
		subline: iwwFreeTrialPreviewFirst(product, ['stoererSubheadline']),
		headline: iwwFreeTrialPreviewFirst(product, ['stoererHeadline']),
		text: iwwFreeTrialPreviewFirst(product, ['shopDescription']),
		image: iwwFreeTrialPreviewFirst(product, ['teaserImageUrl', 'productImageUrl']),
		link: iwwFreeTrialPreviewFirst(product, ['teaserLink', 'url'])
	};
	if (!fields.headline || !iwwFreeTrialPreviewIsWebUrl(fields.link)) return false;
	const buttonText = iwwFreeTrialPreviewFirst(product, ['teaserCallToActionLabel', 'ctatext']) || 'Jetzt kostenlos testen';
	// HTML von Iww.Presentation:Marketing.FreeTrialBanner und seinen Bausteinen,
	// ohne zusaetzliche KachelBox. Dynamics-Bilder behalten runde Ecken.
	// Breite und Abstand liegen am sichtbaren Banner, nicht am leeren Platzhalter.
	const template = document.createElement('template');
	template.innerHTML = `
		<div class="iww-free-trial-banner w-full max-w-full lg:w-[630px] mb-7 rounded-2xl bg-surface-elevated-background p-6 sm:p-7">
			<div class="flex flex-wrap sm:flex-nowrap gap-7 sm:gap-11">
				<div class="w-full sm:w-2/3">
					<h3 class="text-base xmd:text-lg text-neutral text-left mb-0" data-free-trial-field="subline"></h3>
					<h3 class="text-lg xmd:text-xl xl:text-2xl font-medium text-left text-neutral mb-2.5" data-free-trial-field="headline"></h3>
					<p class="text-sm xl:text-base leading-relaxed xl:leading-relaxed mb-7 last:mb-0 text-left text-neutral-subtle" data-free-trial-field="text"></p>
				</div>
				<div class="w-full sm:w-1/3">
					<div class="flex justify-center items-start mb-2.5" data-free-trial-image>
						<div class="w-fit min-w-0 max-w-full overflow-hidden rounded-3xl">
							<img class="block h-auto max-w-full rounded-3xl" data-free-trial-field="image" alt="" loading="lazy"/>
						</div>
					</div>
					<div class="flex flex-wrap sm:flex-nowrap gap-4 mb-7 last:mb-0 justify-center">
						<a class="px-4 py-2 rounded-full inline-flex justify-center items-center text-center font-medium leading-none transition-all hover:scale-105 bg-linear-to-b from-primary-background to-primary-background-dark hover:from-primary-background-dark hover:to-primary-background-dark text-neutral-on-primary text-sm" data-free-trial-field="link"></a>
					</div>
				</div>
			</div>
		</div>
	`;
	// Nur die Shop-Beschreibung erhaelt bereinigtes Rich-Text-Markup.
	template.content.querySelectorAll('[data-free-trial-field]').forEach(field => {
		const name = field.getAttribute('data-free-trial-field');
		const value = fields[name] || '';
		if (!value || (['image', 'link'].includes(name) && !iwwFreeTrialPreviewIsWebUrl(value))) {
			(field.closest('[data-free-trial-image]') || field).remove();
		} else if (name === 'image') {
			field.setAttribute('src', value);
			field.setAttribute('alt', fields.headline || fields.subline);
		} else if (name === 'link') {
			field.setAttribute('href', value);
			field.textContent = buttonText;
		} else if (name === 'text') {
			field.replaceChildren(iwwFreeTrialPreviewShopDescription(value));
			if (!field.textContent.trim()) field.remove();
		} else {
			field.textContent = value;
		}
	});
	element.replaceChildren(template.content);
	return true;
}

async function iwwFreeTrialPreviewLoad(element) {
	if (iwwFreeTrialPreviewInitialized.has(element)) return;
	element.hidden = true;
	// Auch eventuell noch gespeichertes altes Banner-Markup nicht anzeigen.
	element.replaceChildren();
	const imBackend = iwwFreeTrialPreviewIsNeos();
	const informationsdienst = (element.getAttribute('infodienst') || '').trim();
	// Nur im Backend darf die Vorschau den noch unverarbeiteten Wrapper umgehen.
	// Im Frontend bleibt die Abo-Pruefung beim separaten UserVisibility-Tag.
	if (!imBackend && element.closest('iww-dynamiccontent[type="uservisibility"]')) {
		return;
	}
	iwwFreeTrialPreviewInitialized.add(element);
	const showStatus = message => {
		if (!imBackend) return;
		const status = document.createElement('p');
		status.className = 'rounded-2xl bg-surface-elevated-background p-6 sm:p-7';
		status.setAttribute('role', 'status');
		status.textContent = message;
		element.replaceChildren(status);
		element.hidden = false;
	};
	if (!informationsdienst) {
		showStatus('Kein Informationsdienst-Kuerzel ermittelbar.');
		return;
	}
	showStatus('Leseproben-Produkt wird geladen...');
	const identifier = (element.getAttribute('produkt') || '').trim();
	// Im Frontend darf die Box auch spaeter eintreffen.
	try {
		const parameters = new URLSearchParams({informationsdienste: informationsdienst, limit: '1'});
		const deliveryUrl = iwwFreeTrialPreviewBaseUrl.replace(/\/$/, '') + '/api/v1/product/delivery?' + parameters;
		if (!iwwFreeTrialPreviewIsWebUrl(deliveryUrl)) throw new Error('Ungueltige Product-Delivery-URL');
		const products = await iwwFreeTrialPreviewLoadProducts(deliveryUrl, !imBackend);
		if (!element.isConnected) return;
		const product = iwwFreeTrialPreviewFindProduct(products, identifier, informationsdienst);
		if (!product) {
			showStatus('Kein ausspielbares Produkt fuer ' + (identifier || informationsdienst) + ' gefunden.');
		} else if (iwwFreeTrialPreviewRender(element, product)) {
			element.hidden = false;
		} else {
			showStatus('Das Produkt hat keine Ueberschrift oder keinen gueltigen Leseproben-Link.');
		}
	} catch {
		// Keine Fehlermeldung oder leere Box auf der ausgelieferten Seite.
		element.replaceChildren();
		element.hidden = true;
		showStatus('Leseproben-Produkt konnte nicht geladen werden.');
	}
}

function iwwFreeTrialPreviewInit(root) {
	const elements = Array.from(root.querySelectorAll(iwwFreeTrialPreviewSelector));
	if (root.matches && root.matches(iwwFreeTrialPreviewSelector)) elements.unshift(root);
	return Promise.all(elements.map(iwwFreeTrialPreviewLoad));
}

function iwwFreeTrialPreviewStart() {
	iwwFreeTrialPreviewInit(document);
	if (typeof MutationObserver === 'undefined' || !document.body) return;
	new MutationObserver(mutations => {
		mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
			if (node instanceof Element) iwwFreeTrialPreviewInit(node);
		}));
	}).observe(document.body, {childList: true, subtree: true});
}
document.addEventListener('htmx:afterSettle', event => iwwFreeTrialPreviewInit(event.target));
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', iwwFreeTrialPreviewStart);
} else {
	iwwFreeTrialPreviewStart();
}
